import { isType } from 'variant';
import { Type } from '@wix/ambassador-cli-site-override-service-v1-site-override/types';
import type { ComponentOverride } from '@wix/ambassador-cli-site-override-service-v1-site-override/types';
import type { ProjectModel } from '../model.js';
import { DevCenterComponent } from '../dev-center/components/dev-center-component.js';

export function createSiteOverrides(model: ProjectModel) {
  const componentsToOverride = model.components.filter(
    isType(DevCenterComponent.EmbeddedScript)
  );

  if (componentsToOverride.length === 0) {
    return null;
  }

  return componentsToOverride.reduce<Record<string, ComponentOverride>>(
    (acc, component) => {
      const paramsOverride = component.paramsOverride ?? {};

      return {
        ...acc,
        [component.id]: {
          type: Type.EMBEDDED_SCRIPT,
          componentId: component.id,
          embeddedScriptOptions: { parameters: paramsOverride },
        },
      };
    },
    {}
  );
}
